module.exports = __webpack_public_path__ + "img/company-info.7c625ffe.png";